
























import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { VideoElement as VideoElementType } from '@/store/types/element';
import { Getter } from 'vuex-class';
import { RootGettersReturns } from '@/store/types';

@Component({})
export default class MediaFileOverlay extends Vue {
  @Prop({ type: Object }) element!: VideoElementType;
  @Prop(Boolean) isPlaying!: boolean;
  @Prop(Function) setIsVideoPlaying!: (el: HTMLMediaElement) => void;
  @Prop({ type: [HTMLMediaElement, Object] }) media!: HTMLMediaElement;
  @PropSync('display') display2!: boolean;

  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];

  @Watch('element', { deep: true })
  updateElement() {
    this.updateDisplay();
  }

  @Watch('isPlaying')
  updateIsPlaying() {
    this.updateDisplay();
  }

  updateDisplay() {
    this.display2 = this.element.data.state === 'playing' && !this.isPlaying;
  }

  get dimension() {
    return this.element.width > this.element.height ? this.element.height : this.element.width;
  }

  get isWidthTooMuch() {
    return this.element.width / this.element.height > 3;
  }

  get wrapperFontSize() {
    const size = `${this.dimension * (!this.isWidthTooMuch ? 0.5 : 0.8)}px`;
    return {
      fontSize: size,
    };
  }

  get buttonStyle() {
    const size = `${this.dimension * (!this.isWidthTooMuch ? 0.5 : 0.8)}px`;
    return {
      width: size,
      height: size,
    };
  }

  playVideo() {
    this.media.play();
    setTimeout(() => this.setIsVideoPlaying(this.media), 500);
  }
}
